import { actions } from "@/constants/state";
import store from "@/store";

export default async (to, from, next) => {
  try {
    await store.dispatch(actions.HORECA_LOCATIONS_FETCH_ACTION);
  } catch (error) {
    console.error(actions.HORECA_LOCATIONS_FETCH_ACTION, error);
  }

  next();
};
